import React from "react";
import "./LuxuryCards.css";

interface CardItem {
  id: number;
  title: string;
  text: string;
  icon?: React.ElementType; // dynamic icon
}

interface ElegantCardsProps {
  cards?: CardItem[];
}

export default function ElegantCards({ cards = [] }: ElegantCardsProps) {
  return (
    <section className="elegant-section">
      <div className="elegant-grid">
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <div key={card.id} className="elegant-card">
              <div className="elegant-icon">
                {Icon ? <Icon size={38} color="#d9cba8" /> : null}
              </div>
              <h3 className="elegant-title">{card.title}</h3>
              <p className="elegant-text">{card.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}

